module.exports = __webpack_public_path__ + "img/outlandsthumb.3dbc46d9.jpg";